import React from 'react';

export const CreditCardIcon: React.FunctionComponent = () => (
  <div data-hook="wcn-credit-card-icon">
    <img src="https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/creditCard.svg" />
  </div>
);
CreditCardIcon.displayName = 'CreditCardIcon;';
